import {
  FilterType,
  buildPerformanceInsightsSummaryDatatableFilter,
  usePerformanceInsightsSummaryDatatable,
} from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

const employeeFilter = (source: ReturnType<typeof usePerformanceInsightsSummaryDatatable>) => {
  return buildPerformanceInsightsSummaryDatatableFilter(source, {
    title: i18n.t('performance_process.analytics.datatable.filters.employee'),
    path: 'employeeId',
    identifier: 'EmployeeIds',
    type: FilterType.Entity,
    default: false,
    categories: [
      {
        kind: 'Employee',
        operation: 'in',
      },
    ],
    onUpdateValue(value) {
      track(trackingEvents.performanceAnalytics.insightsSummaryFilterApplied, {
        type: 'EmployeeIds',
        value,
      })
    },
  })
}

export default employeeFilter
